import { ReactNode } from 'react'

interface IProps {
  isMultiple: boolean
  singleCategoryComponent: ReactNode
  multipleCategoryComponent: ReactNode
  hasCategories: boolean
  isLoading?: boolean
}

export const SelectCategories = ({
  isMultiple,
  singleCategoryComponent,
  multipleCategoryComponent,
  hasCategories,
  isLoading,
}: IProps) => {
  let result = isMultiple ? multipleCategoryComponent : singleCategoryComponent
  if (isLoading) {
    result = <span>Loading categories...</span>
  } else if (!hasCategories) {
    result = <span>No active categories found</span>
  }

  return <>{result}</>
}
